import type { ReactElement } from 'react';

import { MeetingPairCsvImportPage } from '@/features/events/MeetingPairCsvImportPage';

/** 1on1組み合わせCSV一括作成（D-273） */
export function OneOnOneCsvImportPage(): ReactElement {
  return <MeetingPairCsvImportPage kind="oneonone" />;
}
